"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * keepkey-sdk-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPublicKeyRequestToJSON = exports.GetPublicKeyRequestFromJSONTyped = exports.GetPublicKeyRequestFromJSON = exports.instanceOfGetPublicKeyRequest = exports.GetPublicKeyRequestScriptTypeEnum = void 0;
const runtime_1 = require("../runtime");
const TypesNumericU32_1 = require("./TypesNumericU32");
/**
 * @export
 */
exports.GetPublicKeyRequestScriptTypeEnum = {
    p2pkh: 'p2pkh',
    p2wpkh: 'p2wpkh',
    p2sh_p2wpkh: 'p2sh-p2wpkh'
};
/**
 * Check if a given object implements the GetPublicKeyRequest interface.
 */
function instanceOfGetPublicKeyRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "address_n" in value;
    return isInstance;
}
exports.instanceOfGetPublicKeyRequest = instanceOfGetPublicKeyRequest;
function GetPublicKeyRequestFromJSON(json) {
    return GetPublicKeyRequestFromJSONTyped(json, false);
}
exports.GetPublicKeyRequestFromJSON = GetPublicKeyRequestFromJSON;
function GetPublicKeyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'script_type': !(0, runtime_1.exists)(json, 'script_type') ? undefined : json['script_type'],
        'coin_name': !(0, runtime_1.exists)(json, 'coin_name') ? undefined : json['coin_name'],
        'show_display': !(0, runtime_1.exists)(json, 'show_display') ? undefined : json['show_display'],
        'ecdsa_curve_name': !(0, runtime_1.exists)(json, 'ecdsa_curve_name') ? undefined : json['ecdsa_curve_name'],
        'address_n': (json['address_n'].map(TypesNumericU32_1.TypesNumericU32FromJSON)),
    };
}
exports.GetPublicKeyRequestFromJSONTyped = GetPublicKeyRequestFromJSONTyped;
function GetPublicKeyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'script_type': value.script_type,
        'coin_name': value.coin_name,
        'show_display': value.show_display,
        'ecdsa_curve_name': value.ecdsa_curve_name,
        'address_n': (value.address_n.map(TypesNumericU32_1.TypesNumericU32ToJSON)),
    };
}
exports.GetPublicKeyRequestToJSON = GetPublicKeyRequestToJSON;
